import { Card, Divider, Group, Text, ThemeIcon } from '@mantine/core'
import { IconSettingsSearch } from '@tabler/icons-react'

export const Debug = ({ title, text }: { title: string; text: string[] }) => {
  return (
    <div className={'mx-4'}>
      <Card shadow="sm" padding="sm" radius="md" withBorder>
        <Group gap={'sm'}>
          <ThemeIcon variant={'white'}>
            <IconSettingsSearch />
          </ThemeIcon>
          <Text fw={900}>[DEBUG]</Text>
          <Text fw={500}>{title}</Text>
        </Group>

        {text.map((t, idx) => (
          // biome-ignore lint/suspicious/noArrayIndexKey: デバッグ表示用の静的な行で同じ文字列が重複し得るため index を key に使用
          <div key={idx}>
            <Text size="sm" c="dimmed">
              {t}
            </Text>
            <Divider my={'xs'} />
          </div>
        ))}
      </Card>
    </div>
  )
}
